/**
 * CallbackBanner - live "expecting callback" strip for the current staff
 * member's armed road-call window. Ported from Warpspeed's
 * src/screens/phone/ExpectationBanner/ExpectationBanner.jsx into the local
 * RNW idiom (View/Text/StyleSheet instead of CSS modules).
 */
import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useRoadCallStore, useAuthStore } from '../stores';
import { clearCallExpectation } from '../db_calls_wrapper';
import { formatPhoneNumber } from '../utils/formatting';

function formatRemaining(ms) {
  if (!ms || ms <= 0) return 'expired';
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

const CallbackBanner = () => {
  const callExpectations = useRoadCallStore((s) => s.callExpectations);
  const selectedUser = useAuthStore((s) => s.selectedUser);

  // Tick once a second so the countdown updates live.
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  const myExpectation = (callExpectations || []).find(
    (e) => e && e.userID === selectedUser?.id
  );
  if (!myExpectation) return null;

  const remainingMs = (myExpectation.expiresAt || 0) - Date.now();
  if (remainingMs <= 0) return null;

  const customerLabel =
    myExpectation.customerName || formatPhoneNumber(myExpectation.customerPhone || '');

  const handleCancel = () => {
    clearCallExpectation(myExpectation.customerPhone);
  };

  return (
    <View style={styles.banner}>
      <View style={styles.content}>
        <View style={styles.dot} />
        <View style={styles.textColumn}>
          <Text style={styles.label}>EXPECTING CALLBACK</Text>
          <Text style={styles.customer}>{customerLabel}</Text>
        </View>
        <Text style={styles.countdown}>{formatRemaining(remainingMs)}</Text>
      </View>
      <TouchableOpacity dataSet={{ hover: 'lift' }} onPress={handleCancel} style={styles.cancelBtn}>
        <Text style={styles.cancelText}>CANCEL</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  banner: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#0E7C6B',
    paddingVertical: 8,
    paddingHorizontal: 16,
    position: 'sticky',
    top: 0,
    zIndex: 9998,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    gap: 10,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
  },
  textColumn: {
    flexDirection: 'column',
  },
  label: {
    color: '#FFFFFF',
    fontSize: 11,
    fontWeight: 'bold',
    letterSpacing: 0.5,
  },
  customer: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '600',
  },
  countdown: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 'bold',
    fontVariant: ['tabular-nums'],
    marginRight: 16,
  },
  cancelBtn: {
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 6,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
  cancelText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: 'bold',
  },
});

export default CallbackBanner;
